import { getId, Icon, Modal, Panel, PanelType } from "@fluentui/react";
import { addCartFunc } from "../../../carts/views/CartView";
import { DataUtils } from "../../../common/views/DataUtils";
import ModalHeaderView from "../../../common/views/ModalHeaderView";
import { StyleUtils } from "../../../common/views/StyleUtils";
import { Utils } from "../../../common/views/Utils";
import { ProductKeyModel } from "../../models/ProductModel";
import ProductDetailView from "./ProductDetailView";
import { panelStyles } from "./ProductFilterView";
import { UserProductPictureService } from "./ProductView";

export type ProductDetailWrapperProps = {
    product: ProductKeyModel;
    pictureService: UserProductPictureService;
    isMobile: boolean;
    onClose: () => void;
    addToCart: addCartFunc;
    setFavorite?: (lineId: number, isDeleted: boolean) => void;
}

export default function ProductDetailWrapperView({
    product, pictureService, isMobile, onClose, addToCart, setFavorite
}: ProductDetailWrapperProps) {
    const titleId: string = getId('title');
    const subtitleId: string = getId('subText');

    const detailHeader = () => {
        const title = "Product Details " + product.lineId;
        const widthClass2 = Utils.getColumnWidth(2);
        const widthClass10 = Utils.getColumnWidth(10);

        return <div className="panel-header ph-10">
            <div className={widthClass10}>
                <b>{title}</b>
            </div>
            <div className={widthClass2 + " right"}>
                <Icon iconName="ChromeClose" className="pointer" onClick={onClose} />
            </div>
        </div>
    }

    const detailDesktopView = () => {
        const title = "Product Details " + product.lineId;

        return <>
            <Modal
                titleAriaId={titleId}
                subtitleAriaId={subtitleId}
                isOpen={true}
                onDismiss={onClose}
                isBlocking={false}
                styles={StyleUtils.getModalWidthStyles(1280)}
            >
                <ModalHeaderView title={title} onClose={onClose} />

                <div
                    id={subtitleId}
                    className={(isMobile ? "mobile-" : "") + "popup-body"}
                    style={{ minHeight: "80vh", maxHeight: isMobile ? "" : "80vh", overflowY: "auto" }}
                >
                    <ProductDetailView
                        product={product}
                        pictureService={pictureService}
                        isMobile={isMobile}
                        addToCart={addToCart}
                        setFavorite={setFavorite}
                    />
                </div>
            </Modal>
        </>;
    }

    const detailMobileView = () => {
        return <div>
            <Panel
                isBlocking={false}
                isOpen={true}
                isLightDismiss={false}
                type={PanelType.custom}
                customWidth={DataUtils.PANEL_WIDTH}
                onRenderHeader={detailHeader}
                hasCloseButton={false}
                styles={{
                    header: panelStyles.header,
                    content: { paddingLeft: "10px !important", paddingRight: "10px !important" }
                }}
            >
                <div className="ms-Grid">
                    <ProductDetailView
                        product={product}
                        pictureService={pictureService}
                        isMobile={isMobile}
                        addToCart={addToCart}
                        setFavorite={setFavorite}
                    />
                </div>
            </Panel>
        </div>;
    }

    return <>
        {detailDesktopView()}
    </>;
}